// extracted by mini-css-extract-plugin
export var actionButton = "_wy-2";
export var card = "_wy-0";
export var disambiguationList = "_wy-3";
export var errorCard = "_wy-4";
export var row = "_wy-1";